export default __webpack_public_path__ + "static/media/youtube.38853f54.svg";